import { boot } from 'quasar/wrappers';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue, { BugsnagPluginVueResult } from '@bugsnag/plugin-vue';

export default boot(({ app }) => {
	Bugsnag.start({
		apiKey: process.env.BUGSNAG_API_KEY as string,
		plugins: [new BugsnagPluginVue()],
		appVersion: process.env.VERSION,
		releaseStage: process.env.RELEASE as string,
	});

	app.use(Bugsnag.getPlugin('vue') as BugsnagPluginVueResult);
});
